import { useEffect } from "react";
import { api, API } from "@/lib/site";
import { getVisitorId } from "@/lib/analytics";

// Tracks a page visit and reports time-on-page via heartbeats + unload beacon.
export function usePageTracking(path) {
  useEffect(() => {
    let eventId = null;
    const start = Date.now();
    let cancelled = false;

    api
      .post("/analytics/track", {
        visitor_id: getVisitorId(),
        path,
        referrer: document.referrer || "",
        type: "page",
      })
      .then((r) => {
        if (!cancelled) eventId = r.data.event_id;
      })
      .catch(() => {});

    const elapsed = () => Math.round((Date.now() - start) / 1000);

    const sendBeacon = () => {
      if (!eventId) return;
      const body = JSON.stringify({ event_id: eventId, duration_seconds: elapsed() });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/analytics/heartbeat`, new Blob([body], { type: "application/json" }));
      }
    };

    const send = () => {
      if (!eventId) return;
      api.post("/analytics/heartbeat", { event_id: eventId, duration_seconds: elapsed() }).catch(() => {});
    };

    const interval = setInterval(send, 15000);
    const onVisibility = () => {
      if (document.visibilityState === "hidden") sendBeacon();
    };
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pagehide", sendBeacon);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pagehide", sendBeacon);
      send();
    };
  }, [path]);
}
